(() => {
  const motionEnabled=document.body.dataset.padMotion!=='false';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new Map();
  const ease = 'cubic-bezier(.22,.8,.22,1)';
  function mount(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const animations = new Set();
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        if (!motionEnabled || reduced.matches || window.Shopify?.designMode || entry.target.closest('.pad-scene')) continue;
        const animation = entry.target.animate([{transform:'translateY(36px)'},{transform:'translateY(0)'}], {duration:650,easing:ease});
        animations.add(animation);
        animation.finished.catch(()=>{}).finally(()=>animations.delete(animation));
      }
    }, {threshold:.08});
    root.querySelectorAll('[data-pad-reveal], .cafe-selection-index, .pad-footer-closing').forEach(node=>observer.observe(node));
    const photos = [...root.querySelectorAll('[data-pad-parallax]')];
    let frame = 0;
    function paint() {
      frame = 0;
      for (const node of photos) {
        const bounds = node.getBoundingClientRect();
        if (bounds.bottom < 0 || bounds.top > innerHeight) continue;
        const progress = Math.min(1, Math.max(0, (innerHeight-bounds.top)/(innerHeight+bounds.height)));
        node.style.setProperty('--pad-depth', (!motionEnabled||reduced.matches) ? '0px' : `${-progress*48}px`);
      }
    }
    function update(){if(!frame)frame=requestAnimationFrame(paint);}
    addEventListener('scroll',update,{passive:true,signal});
    addEventListener('resize',update,{passive:true,signal});
    reduced.addEventListener('change',()=>{animations.forEach(a=>a.cancel());paint();},{signal});
    paint();
    root.querySelectorAll('[data-pad-tabs]').forEach(group=>{
      const tabs=[...group.querySelectorAll('[data-pad-tab]')];
      const panels=[...group.querySelectorAll('[data-pad-tab-panel]')];
      const select = index => {
        tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;});
        panels.forEach((panel,i)=>{panel.hidden=i!==index;if(i===index&&!reduced.matches)panel.animate([{transform:'translateX(20px)'},{transform:'translateX(0)'}],{duration:360,easing:ease});});
      };
      tabs.forEach((tab,index)=>{
        tab.addEventListener('click',()=>select(index),{signal});
        tab.addEventListener('keydown',event=>{
          let next=index;
          if(event.key==='ArrowRight')next=(index+1)%tabs.length;
          else if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
          else if(event.key==='Home')next=0;
          else if(event.key==='End')next=tabs.length-1;
          else return;
          event.preventDefault();select(next);tabs[next].focus();
        },{signal});
      });
      if(tabs.length) select(0);
    });
    instances.set(root,()=>{controller.abort();observer.disconnect();animations.forEach(a=>a.cancel());cancelAnimationFrame(frame);photos.forEach(p=>p.style.removeProperty('--pad-depth'));});
  }
  function mountAll(root=document){root.querySelectorAll('.shopify-section').forEach(mount);}
  mountAll();
  document.addEventListener('shopify:section:load',event=>mount(event.target));
  document.addEventListener('shopify:section:unload',event=>{instances.get(event.target)?.();instances.delete(event.target);});
  document.addEventListener('shopify:section:select',event=>{event.target.getAnimations({subtree:true}).forEach(a=>a.finish());});
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const cursor = document.createElement('span');
  cursor.className='pad-cursor';cursor.setAttribute('aria-hidden','true');
  document.body.append(cursor);
  function pointerMode(){document.documentElement.classList.toggle('pad-custom-cursor',fine.matches&&!reduced.matches);cursor.dataset.visible='false';document.documentElement.dataset.padPointerVisible='false';}
  pointerMode();fine.addEventListener('change',pointerMode);reduced.addEventListener('change',pointerMode);
  document.addEventListener('pointermove',event=>{
    if(!fine.matches||reduced.matches)return;
    const target=event.target;
    if(!(target instanceof Element))return;
    const native=target.closest('input,textarea,select,iframe,dialog,canvas.pad-cup-viewer');
    const visible=!native&&!document.querySelector('dialog[open]');cursor.dataset.visible=String(visible);document.documentElement.dataset.padPointerVisible=String(visible);
    cursor.style.transform=`translate(${event.clientX}px,${event.clientY}px) translate(-50%,-50%)`;
    const control=target.closest('a,button,summary,[role="button"],[data-pad-drag]');
    const drag=control?.hasAttribute('data-pad-drag');
    cursor.dataset.state=control?(drag?'drag':'link'):'default';cursor.textContent=control?(drag?'↔':'+'):'';
    cursor.dataset.inverse=String(Boolean(target.closest('[data-pad-dark],.pad-coffee-story,.pad-visit-arrival,.pad-map-location,.pad-extras label:has(input:checked),.pad-navigation-links,.pad-navigation-order,.pad-added-notice,button[aria-pressed=true],.pad-button,.cafe-configure')));
  },{passive:true});
  document.addEventListener('pointerout',event=>{if(!event.relatedTarget){cursor.dataset.visible='false';document.documentElement.dataset.padPointerVisible='false';}});
  document.addEventListener('keydown',()=>{cursor.dataset.visible='false';document.documentElement.dataset.padPointerVisible='false';});
})();
